/**
 * Generated from ch5_p07.fla
 */
export function ch5_p07(this: Ich5_p07) {
	const lights = this.lights;
	if (!lights[0] && lights.elementFactory) {
		lights[0] = lights.elementFactory(0,undefined);
	}
	if (lights[0]) {
		ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightLayer294copy.call(lights[0] as Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightLayer294copy);
		lights[0].x = 997.75;
		lights[0].y = 380.5;
		lights[0].width = 804.50;
		lights[0].height = 761.00;
		lights[0].alpha = 1;
		if (lights[0].onLayout) lights[0].onLayout();
	}
	if (!lights[1] && lights.elementFactory) {
		lights[1] = lights.elementFactory(1,undefined);
	}
	if (lights[1]) {
		ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightnolines.call(lights[1] as Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightnolines);
		lights[1].x = 891;
		lights[1].y = 384;
		lights[1].width = 1061.00;
		lights[1].height = 768.00;
		lights[1].alpha = 1;
		if (lights[1].onLayout) lights[1].onLayout();
	}
	const bg = this.bg;
	ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hollyHorse = this.hollyHorse;
	ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_hollyhorse.call(this.hollyHorse);
	hollyHorse.x = 781;
	hollyHorse.y = 442;
	hollyHorse.width = 492.00;
	hollyHorse.height = 652.00;
	hollyHorse.alpha = 1.00;
	if (hollyHorse.onLayout) hollyHorse.onLayout();
	const butterfly = this.butterfly;
	ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_butterfly.call(this.butterfly);
	butterfly.x = 1068.5;
	butterfly.y = 248.5;
	butterfly.width = 56.00;
	butterfly.height = 67.00;
	butterfly.alpha = 1.00;
	if (butterfly.onLayout) butterfly.onLayout();
	const frameRight = this.frameRight;
	ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0.5;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_bg(this: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p07_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightLayer294copy(this: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightLayer294copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer294copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightnolines(this: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightnolines) {
	if (this.setLayoutTexture) this.setLayoutTexture("nolines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_hollyhorse(this: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_hollyhorse) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p07_hollyhorse", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_butterfly(this: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_butterfly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p07_butterfly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeRframe(this: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeLframe(this: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich5_p07Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p07Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p07Sprite extends Ich5_p07Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p07Text extends Ich5_p07Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p07Polygon extends Array<number> {
}
interface Ich5_p07 {
	readonly lights: Ich5_p07Array<Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightLayer294copy|Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightnolines>;
	readonly bg: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_bg;
	readonly hollyHorse: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_hollyhorse;
	readonly butterfly: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_butterfly;
	readonly frameRight: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeRframe;
	readonly frameLeft: Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeLframe;
}
interface Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_bg extends Ich5_p07Sprite {
}
interface Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightLayer294copy extends Ich5_p07Sprite {
}
interface Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_lightnolines extends Ich5_p07Sprite {
}
interface Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_hollyhorse extends Ich5_p07Sprite {
}
interface Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_butterfly extends Ich5_p07Sprite {
}
interface Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeRframe extends Ich5_p07Sprite {
}
interface Ich5_p07_hh_ch5_72dpi_p07psdAssetch5_p07_wcframeLframe extends Ich5_p07Sprite {
}
